import { type FeatureFlagPayloadMap } from '@posthog-app/use-feature-flag';

/**
 * Defensive read of the `floorplan-interactive-editor` flag + payload. Returns
 * false if the payload is malformed (missing `allowedCompanyIds`, wrong type),
 * so a bad edit in the PostHog UI can't break floorplan navigation.
 */
export const shouldShowFloorplanV2 = (
  isFlagEnabled: boolean,
  payload: FeatureFlagPayloadMap['floorplan-interactive-editor'] | undefined,
  companyLegacyId: string
): boolean => {
  const allowedCompanyIds = payload?.allowedCompanyIds;
  return isFlagEnabled && Array.isArray(allowedCompanyIds) && allowedCompanyIds.includes(Number(companyLegacyId));
};
